import styled from "@emotion/styled";

export const Logo = styled.div`
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 10px;
    margin-bottom: 30px;
    
`

